// login.component.ts
import { Component, OnInit } from '@angular/core';
import { Router }      from '@angular/router';
import { ProfileService } from '../../../@inax/common';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'service-login',
  templateUrl: 'app/components/serviceLogin/serviceLogin.component.html',
  styleUrls: [ 'app/components/serviceLogin/serviceLogin.component.css' ]
})
export class ServiceLoginComponent implements OnInit {

  public loggedIn: boolean = false;
  public username: string = "";
  public password: string = "";
  public message:string = "";

  constructor(
    private _userService: ProfileService,
    private _router: Router
  ) 
  {
    this.loggedIn = _userService.isAuthenticated();
  }

  ngOnInit(){

  }

  login() {
    if (!this.loggedIn) {
      this.message = "";
      this._userService.login(this.username, this.password).subscribe((result) => {
        if (result) {
          this._router.navigate(['Home']);
        } else {
          this.message = "Not logged in"
          console.warn(this.message);
          this.loggedIn = this._userService.isAuthenticated();
        }
      });
    }
  }

  logout() {
    if (this.loggedIn) {
      this._userService.logout();
      this.loggedIn = this._userService.isAuthenticated();
    }
  }


  useAdmin(){
    this.username = 'admin@insite-gmbh.de';
    this.password = 'InsiteAdm#1';
    this.login();
  }

  useUser(){
    this.username = 'user@insite-gmbh.de';
    this.password = 'InsiteUsr#1';
    this.login();
  }
}